






import { defineComponent } from '@vue/composition-api';

const Progressbar = defineComponent({
  // setup() {},
  props: {
    value: {
      type: String,
      default() { return '0'; },
    },
  },
});

export default Progressbar;
